// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mr-1";
export var messageSideRight = "_mr-2";
export var subscribeToBackInStockBubbleContainer = "_mr-0";